import { createAction, props } from '@ngrx/store';
import { IBasicData, IField } from '@shared/model/basic-data';

export enum BasicDataActionTypes {
  GET_BASIC_DATA = '[Basic Data] Get Basic Data',
  GET_BASIC_DATA_SUCCESS = '[Basic Data] Get Basic Data Success',
  GET_BASIC_DATA_FAILURE = '[Basic Data] Get Basic Data Failure',

  UPDATE_BASIC_DATA = '[Basic Data] Update Basic Data',
  UPDATE_BASIC_DATA_SUCCESS = '[Basic Data] Update Basic Data Success',
  UPDATE_BASIC_DATA_FAILURE = '[Basic Data] Update Basic Data Failure',

  CLEAR_BASIC_DATA = '[Basic Data] Clear Basic Data',
}

export const getBasicData = createAction(BasicDataActionTypes.GET_BASIC_DATA, props<{ id: number }>());

export const getBasicDataSuccess = createAction(
  BasicDataActionTypes.GET_BASIC_DATA_SUCCESS,
  props<{ basicData: IBasicData }>(),
);

export const getBasicDataFailure = createAction(BasicDataActionTypes.GET_BASIC_DATA_FAILURE);

export const updateBasicData = createAction(
  BasicDataActionTypes.UPDATE_BASIC_DATA,
  props<{ id: number; data: IField }>(),
);

export const updateBasicDataSuccess = createAction(
  BasicDataActionTypes.UPDATE_BASIC_DATA_SUCCESS,
  props<{ data: IField }>(),
);

export const updateBasicDataFailure = createAction(BasicDataActionTypes.UPDATE_BASIC_DATA_FAILURE);

export const clearBasicData = createAction(BasicDataActionTypes.CLEAR_BASIC_DATA);
